module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no_warnings":"No warnings","warningsCount":"{n} Warning | {n} Warnings"},"de":{"no_warnings":"Keine Warnungen","warningsCount":"{n} Warnung | {n} Warnungen"},"fr":{"no_warnings":"Aucun avertissement","warningsCount":"{n} Avertissement | {n} Avertissements"},"it":{"no_warnings":"Nessun avviso","warningsCount":"{n} Avviso | {n} Avvisi"}}')
  delete Component.options._Ctor
}
